import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import { slikeVPEvents, videoEventsMap } from '../../constants';
import { AnalyticsGA } from '../../utils/lib/analytics';

/**
 * Return sg value using audiences
 */
const getSGValue = () => {
  let _auds = '';
  if (typeof window !== 'undefined' && typeof window.colaud !== 'undefined') {
    _auds = _get(window.colaud, 'colaud.auds');
  } else if (
    typeof localStorage !== 'undefined' &&
    typeof localStorage.getItem('colaud') !== 'undefined' &&
    localStorage.getItem('colaud') !== null
  ) {
    _auds = localStorage.getItem('colaud');
  }
  return _auds;
};

/**
 * Return colombia uuid cookie val
 */
const getColombiaCookieVal = () => {
  if (typeof window !== 'undefined') {
    return Cookie.get('_col_uuid') || '';
  }
  return '';
};

/**
 * Default configuration for video player widget.
 */
const getDefaultConfig = () => ({
  config: {
    apiKey: 'toiamp5t9tCpb7nb5q6jUb',
    contEl: 'masterVideoPlayer',
    controls: {
      dock: false,
    },
    colombiaCookieId: getColombiaCookieVal(),
    video: {
      id: '',
      playerType: '',
      image: '',
      title: '',
      startTime: 0,
      pid: '', //agency
      msid: '',
      shareUrl: '',
    },
    player: {
      // adSection: 'default',
      contWidth: document.getElementById('masterVideoPlayer').offsetWidth || 0,
      contHeight:
        document.getElementById('masterVideoPlayer').offsetHeight || 0,
      pageSection: '',
      playsInline: true,
      autoPlay: true,
      fallbackMute: true,
      mute: true,
      skipAd: true,
      volume: 70,
      playlistUrl: '',
      playlist: true,
      isAMP: true,
      pid: 'TOI.in',
      sg: getSGValue(),
      scrollBehaviour: {
        inViewPercent: 80,
        dock: true,
        autoPlay: true,
      },
    },
  },
  playerEvents: {
    onVideoRequest: ({ player, eventName, eventData }) => {
      AnalyticsGA.makeGAForVideoEvents({
        eventData,
        eventType: eventName,
        player,
      });
    },
    onVideoLoadRequest: ({ player, eventName, eventData }) => {
      AnalyticsGA.makeGAForVideoEvents({
        eventData,
        eventType: eventName,
        player,
      });
    },
    onVideoReady: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForVideoEvents({
        eventData,
        eventType,
        player,
      });
    },
    onVideoStarted: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForVideoEvents({
        eventData,
        eventType,
        player,
      });
    },
    onVideoCompleted: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForVideoEvents({
        eventData,
        eventType,
        player,
      });
    },
  },
  adEvents: {
    onAdRequest: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForAdEvents({
        eventData,
        eventType,
        player,
      });
    },
    onAdComplete: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForAdEvents({
        eventData,
        eventType,
        player,
      });
    },
    onAdLoaded: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForAdEvents({
        eventData,
        eventType,
        player,
      });
    },
    onAdView: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForAdEvents({
        eventData,
        eventType,
        player,
      });
    },
    onAdSkip: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForAdEvents({
        eventData,
        eventType,
        player,
      });
    },
    onAdError: ({ player, eventName, eventData }) => {
      const eventType = slikeVPEvents[eventName]
        ? videoEventsMap[slikeVPEvents[eventName]]
        : null;
      AnalyticsGA.makeGAForAdEvents({
        eventData,
        eventType,
        player,
      });
    },
  },
});
export default getDefaultConfig;
